<template>
    <Title_Base :icon="icon" :title="text">
    </Title_Base>
</template>


<script>
import Title_Base from "@/components/SingleUse/ComponentOverrides/pagetitle/Title_Base.vue";

export default {
    name: 'Title_Job',
    props: {},
    components: {
        Title_Base,
    },

    data() {
        return {
        };
    },

    methods: {},

    computed: {
        icon() {
            return "$job";
        },

        text() {
            const statusParam = this.$route.params?.statusId;
            const substatusPageParam = this.$route.params?.subStatusId;

            var output = this.$t('servicesystem.common_objects.job.job_list');
            if (statusParam) {
                var status = this.$store.getters["LookUpStore/JobStatus"](statusParam);
                if (status) {
                    output = output + ` - ${status.Name}`;
                }
            }
            if (substatusPageParam) {
                var substatus = this.$store.getters['LookUpStore/JobSubStatus'](substatusPageParam);
                if (substatus) {
                    output = output + ` - ${substatus.Name}`;
                }
            }
            return output;
        },
    },

    watch: {},
};
</script>


<style lang='scss' scoped></style>